module.exports = __webpack_public_path__ + "img/bible-search.df91af62.png";